import styles from "./Input.module.css";
const Input = (props) => {
  let classes;
  if (props.className) {
    classes =
      styles["input"] + " " + props.className;
  } else {
    classes = styles["input"];
  }
  return (
    <input
      {...props}
      className={classes}
    />
  );
};

export default Input;
